export default class FreeArea {
  constructor() {
    this.elFirst = document.querySelector('.js-freeArea-first')
    this.elSecond = document.querySelector('.js-freeArea-second')

    if (!this.elFirst && !this.elSecond) {
      return
    }

    this.createFreeArea()
  }

  createFreeAreaData(data) {
    const result = data.filter((value) => {
      return (
        (value.area === '07' && value.show !== '0') ||
        (value.area === '19' && value.show !== '0')
      )
    })

    return result
  }

  createFreeArea() {
    const freeAreaData = this.createFreeAreaData(window.LIVESTATION.MAINCONTENT)

    if (!freeAreaData.length) {
      return
    }

    for (const item of freeAreaData) {
      switch (true) {
        case item.area === '07':
          item.remarks && item.show === '1'
            ? (this.elFirst.innerHTML = item.remarks)
            : false
          item.remarks && item.show === '1'
            ? this.attachEventTrack(this.elFirst)
            : false
          break
        case item.area === '19':
          item.remarks && item.show === '1'
            ? (this.elSecond.innerHTML = item.remarks)
            : false
          item.remarks && item.show === '1'
            ? this.attachEventTrack(this.elSecond)
            : false
          break
        default:
          break
      }
    }
  }

  async attachEventTrack(el) {
    try {
      const items = el.querySelectorAll(
        '.js-trackEvent'
      )

      if (!items.length) {
        return
      }

      const { attachEventTrack } = await import(
        /* webpackChunkName: "track" */
        './trackEvent/track'
      )

      attachEventTrack(items)
    } catch (error) {
      console.log(error)
    }
  }
}
